import React from 'react';
import {parseISO, format} from 'date-fns';
import DownloadOutlined from '@ant-design/icons/lib/icons/DownloadOutlined';
import {getRemarkAttachedFile} from '../../../../../services/findings';
import {Tooltip} from 'antd';
import {FINDING_STATUS} from "../../../const";
import {getLanguage, t} from 'react-switch-lang';

const FindingComment = ({comment}) => {
    const {
        createdAt,
        content,
        createdBy,
        files,
        findingCompletionProofFile,
        proposedDeadline,
        findingCompletionProof,
        responsiblePersonFindingStatus,
        progressPercentage
    } = comment;
    const makeInitials = () => {
        const initials = [];
        if (createdBy.firstName) initials[0] = createdBy.firstName[0];

        if (createdBy.lastName) initials[1] = createdBy.lastName[0];

        return initials.join('');
    };

    const avatar = createdBy.imageUrl ? (<img src={createdBy.imageUrl} alt="Avatar"/>) : (`${makeInitials()}`);
    return (<div className="findings-remarks-document-comment">
            <div className="findings-remarks-document-comment__image">
                <div className="avatar-pic avatar-user">{avatar}</div>
            </div>
            <div className="findings-remarks-document-comment__data">
                <div className="findings-remarks-document-comment__info">
                    <p className="findings-remarks-document-comment__author">
                        {createdBy.firstName + ' ' + createdBy.lastName}
                    </p>
                    <p className="findings-remarks-document-comment__date">
                        {format(parseISO(createdAt), 'dd.MM.yyyy. | HH:mm') + ' h'}
                    </p>
                </div>
                <div className="findings-remarks-document-comment__text">
                    <p>{content}</p>
                    {proposedDeadline && (<p style={{fontWeight: '400'}}>
                            {t('revisions.proposedDeadline')}:
                            <b>{format(parseISO(proposedDeadline), 'dd.MM.yyyy.')}</b>
                        </p>)}
                    {(progressPercentage !== null) && (<p style={{fontWeight: '400'}}>
                            {t('revisions.progressPercentage')}:
                            <b>{progressPercentage + '%'}</b>
                        </p>)}
                    {(responsiblePersonFindingStatus !== null) && (<p style={{fontWeight: '400'}}>
                            {t('revisions.responsiblePersonFindingStatus')}:
                            <b>{FINDING_STATUS[responsiblePersonFindingStatus][getLanguage() === 'eng' ? 'en' : getLanguage()]}</b>
                        </p>)}

                  {files.length > 0 && files.map((file) => (<>
                    {file.attachmentFileType === "REMARK_ATTACHMENT" &&
                      <div className="findings-remarks-file-download mt-1">
                        <Tooltip title={file.fileName}>
                          <span className={'fileName'}>{file.fileName}</span>
                        </Tooltip>
                        <DownloadOutlined
                            onClick={() => {
                              try {
                                getRemarkAttachedFile(file);
                              } catch (e) {
                                console.log(e);
                              }
                            }}
                            style={{fontSize: '16px', color: '#08c', cursor: 'pointer'}}
                        />
                      </div>
                    }
                  </>))}

                    {(findingCompletionProof?.length > 0 && findingCompletionProof !== null) && (
                        <p className={'mt-2'} style={{fontWeight: '400'}}>
                            {t('comments.proofOfRealization')}:
                            <b> {findingCompletionProof}</b>
                        </p>)}

                    {files.length > 0 && files.map((file) => (<>
                            {file.attachmentFileType === 'FINDING_COMPLETION_PROOF' && <>  <label style={{
                                marginBottom: '6px'
                            }}>{t('comments.proofOfRealizationFile')}:</label>
                                <div className="findings-remarks-file-download mt-1">
                                    <Tooltip title={file.fileName}>
                                        <span className={'fileName'}>{file.fileName}</span>
                                    </Tooltip>
                                    <DownloadOutlined
                                        onClick={() => {
                                            try {
                                                getRemarkAttachedFile(file);
                                            } catch (e) {
                                                console.log(e);
                                            }
                                        }}
                                        style={{fontSize: '16px', color: '#08c', cursor: 'pointer'}}
                                    />
                                </div>
                            </>

                            }
                        </>))}

                    {findingCompletionProofFile?.length > 0 && findingCompletionProof && <><label style={{
                        paddingTop: '10px',
                        marginBottom: '10px'
                    }}>{t('comments.proofOfRealizationFile')}:</label>
                        <div className="findings-remarks-file-download">
                            <Tooltip title={findingCompletionProofFile?.fileName}>
                                <span className={'fileName'}>{findingCompletionProofFile?.fileName}</span>
                            </Tooltip>
                            <DownloadOutlined
                                onClick={() => {
                                    try {
                                        getRemarkAttachedFile(findingCompletionProofFile);
                                    } catch (e) {
                                        console.log(e);
                                    }
                                }}
                                style={{fontSize: '16px', color: '#08c', cursor: 'pointer'}}
                            />
                        </div>
                    </>}
                </div>
            </div>
        </div>);
};

export default FindingComment;
